import React from 'react';
import { Link } from "react-router-dom";
import NueroLogo from "../../assets/images/neura-academy-logo.png";

function Navbar() {
  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-for-landing-page bg-fffef8 style-lms-nav py-30"
        id="navbar"
      >
        <div className="container cmw-1704">
          <Link className="navbar-brand" to="/" reloadDocument>
            <img src={NueroLogo} className="black-logo" alt="NeuraAcademy" style={{ width: 250, height: 100, objectFit: "contain" }} />
            <img src={NueroLogo} className="white-logo d-none" alt="NeuraAcademy" style={{ width: 250, height: 100, objectFit: "contain" }} />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            id="navbar_toggler"
          >
            <span className="border-bottom border-3 border-white top" />
            <span className="border-bottom border-3 border-white middle my-5px" />
            <span className="border-bottom border-3 border-white bottom" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav m-auto">
              <li className="nav-item">
                <Link className="nav-link fs-16 fw-medium hover p-0 active" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link fs-16 fw-medium hover p-0" to="/courses">
                  Courses
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link fs-16 fw-medium hover p-0" to="/resources">
                  Resources
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link fs-16 fw-medium hover p-0" to="/contact">
                  Contact
                </Link>
              </li>
            </ul>
            <div className="others d-flex align-items-center position-relative z-2" style={{ marginTop: 0 }}>
              <Link
                to="/courses"
                className="btn btn-outline-primary-div-50 fw-medium fs-16 text-primary-div-50 rounded-2 d-flex align-items-center"
                style={{ gap: 5, background: "transparent", border: "1.5px solid currentColor", textDecoration: "none", whiteSpace: "nowrap" }}
              >
                <i className="material-symbols-outlined fs-24">school</i>
                <span>Get Started</span>
              </Link>
            </div>
          </div>
        </div>
      </nav>

    </>
  );
}

export default Navbar;
